import React, { Component } from 'react';
import { scrollSpy } from 'react-scroll';
import NavLink from './NavLink';

import './MobileNavigation.css';

export default class MobileNavigation extends Component {
  componentDidMount() {
    scrollSpy.update();
  }

  render() {
    return (
      <nav className="MobileNavigation">
        <NavLink to="work" title={<i className="material-icons">work</i>} />
        <NavLink to="skills" title={<i className="material-icons">extension</i>} />
        <NavLink to="about" title={<i className="material-icons">person</i>} />
        <NavLink to="contact" title={<i className="material-icons">email</i>} />
      </nav>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/MobileNavigation.js